import React, { useMemo } from 'react'
import moment, { Moment } from 'moment-timezone'
import { useTenantTimezone } from '../shared/contexts'

interface WeekViewProps {
  selectedDate: Moment
  selectedWeekDay: Moment
  onDayClick: (day: Moment) => void
}

const WeekView = ({ selectedDate, selectedWeekDay, onDayClick }: WeekViewProps) => {
  const tenantTz = useTenantTimezone()
  // "Today" highlight uses the tenant's wall clock, not the browser's.
  const today = moment.tz(tenantTz)

  const weekDays = useMemo(() => {
    const startOfWeek = selectedDate.clone().startOf('isoWeek')
    return Array.from({ length: 7 }, (_, i) => startOfWeek.clone().add(i, 'days'))
  }, [selectedDate])

  return (
    <div className="menu-week-days">
      {weekDays.map((day, index) => {
        const isPast = day.isBefore(today, 'day')
        const isToday = day.isSame(today, 'day')
        const isSelected = day.isSame(selectedWeekDay, 'day')

        return (
          <div
            key={index}
            className={`day-card ${isPast ? 'past' : ''} ${isSelected ? 'active' : ''} ${isToday ? 'today' : ''}`}
            onClick={() => onDayClick(day)}
            style={{ cursor: 'pointer' }}
          >
            <span className="day-name">{day.format('ddd')}</span>
            <span className="day-date">{day.format('MMM D')}</span>
          </div>
        )
      })}
    </div>
  )
}

export default WeekView
